<script setup>
import { useFeedbackEntry } from '@core/stores/feedback-entry'

import { userAuthState } from '@/@core/auth'
import { cookieRef } from '@/@layouts/stores/config'
import CustomerFetchDialog from '@/views/customer/dialogs/CustomerFetchDialog.vue'
import AssortedFeedbackQuestion from '@/views/feedback/feedback-entry/tabs/AssortedFeedbackQuestion.vue'
import CustomerInfo from '@/views/feedback/feedback-entry/tabs/CustomerInfo.vue'
import FeedbackType from '@/views/feedback/feedback-entry/tabs/FeedbackType.vue'
import StandardFeedbackQuestion from '@/views/feedback/feedback-entry/tabs/StandardFeedbackQuestion.vue'
import { VOtpInput } from 'vuetify/labs/VOtpInput'

definePage({
  meta: {
    name: 'feedback-entry',
    subject: 'feedback.feedback',
    action: 'create',
  },  
})

const { t } = useI18n()

const route = useRoute('feedback-collection')
const feedbackId = ref(0)

const iconsSteps = [
  {
    title: 'Feedback Details',
  },
  {
    title: t('Customer')+' Info',
  },
  {
    title: 'Feedback Form',
  },
  {
    title: 'Review & Submit',
  },
]

const isCustomerDialogOpen = ref(false)

const refFeedbackTypeForm = ref()

const feedbackTypeFormData = ref({
  customerType: null,
  sourceType: null,
  formType: null,
})

useFeedbackEntry().fetchFormTypes()
useFeedbackEntry().fetchSourceTypes(route.name === 'app-feedback-entry-assorted' ? 'assorted' : 'standard')

const refCustomerInfoForm = ref()

const customerInfoFormData = ref({
  name: '',
  phone: '',
  email: '',
  uhid: '',
  episode_no: '',
  location: '',
  customer_id: null,
  unit_id: null,
  episode_id: null,
  feedback_datetime: null,
  doctor_name: null,
})

const feedbackFormData = ref({})
const currentStep = ref(0)
const isCurrentStepValid = ref(true)


const validateFeedbackTypeForm = () => {
  refFeedbackTypeForm.value?.validate().then(valid => {
    if (valid.valid) {
      currentStep.value++
      isCurrentStepValid.value = true
      useFeedbackEntry().updateCurrentFeedback({
        customer_type: feedbackTypeFormData.value?.customerType,
        source_type: feedbackTypeFormData.value?.sourceType,
        form_type: feedbackTypeFormData.value?.formType,
        feedback_type: type.value,
        feedback: [],

      })
      nextTick(() => {
        refFeedbackTypeForm.value?.resetValidation()
        refFeedbackForm.value?.reset()
      })
    } else {
      isCurrentStepValid.value = false
    }
  })
}

const validateCustomerInfoForm = () => {
  refCustomerInfoForm.value?.resetValidation()

  if(customerInfoFormData.value?.customer_id !== null){
    updateCustomerInfoFormData()
  }
  refCustomerInfoForm.value?.validate().then(valid => {
    if (valid.valid) {
      currentStep.value++
      isCurrentStepValid.value = true
      nextTick(() => {
        refCustomerInfoForm.value?.resetValidation()
        updateCustomerInfoFormData()
      })
    } else {
      isCurrentStepValid.value = false
    }
  })
}

const refFeedbackForm = ref()

const updateCustomerInfoFormData =()=> {
  useFeedbackEntry().updateCurrentFeedback({
    customer: customerInfoFormData.value,
    unit_id: cookieRef('selectedUnit'),
    feedback: [],
  })
  refFeedbackForm.value?.reset()

}


const validateFeedbackForm = () => {
  refFeedbackForm.value?.validate().then(valid => {
    if (valid.valid) {
      currentStep.value++
      isCurrentStepValid.value = true
      useFeedbackEntry().updateCurrentFeedback({
        feedback: feedbackFormData.value?.filter(item => {
          if (item.response !== null && item.response !== '' && item.response !== undefined) {
            return item
          }
          
        }),
      })
      nextTick(() => {
        refFeedbackForm.value?.resetValidation()
      })
    } else {

      isCurrentStepValid.value = false
    }
  })
}

const resetFeedbackForm = () => {
  refFeedbackForm.value?.reset()
  useFeedbackEntry().updateCurrentFeedback({
    feedback: [],
  })
}

watch(feedbackFormData, () => {
  if (Array.isArray(feedbackFormData.value) && feedbackFormData.value.length > 0){
    useFeedbackEntry().updateCurrentFeedback({
      feedback: feedbackFormData.value?.filter(item => {
        if (item.response !== null && item.response !== '' && item.response !== undefined) {
          return item
        }
          
      }),
    })
  }
}, {
  immediate: true,
  deep: true,
})

const updateCurrentStep = value => {
  currentStep.value = value
}

const type = computed(() => route.name === 'app-feedback-entry-assorted' ? 'assorted' : 'standard')

// const breadcrumbs = computed(() => {
//   return [
//     { 
//       title: 'Feedback Entry',
//     },
//     { 
//       title: type.value === 'assorted' ? 'Assorted' : 'Standard',
//       to: type.value === 'assorted' ? '/app/feedback/entry/assorted' : '/app/feedback/entry',
//     },
//     {
//       title: 'Collect',
//     },
//   ]
// })

const questionFeedbackComponent= computed(() => {
  return type.value==='assorted' ? AssortedFeedbackQuestion : StandardFeedbackQuestion
})

const submitLocation = ref(false)



const onSuccess = data => {
  //  reset customerInfoFormData and feedbackTypeFormData
  customerInfoFormData.value = {
    name: '',
    phone: '',
    email: '',
    uhid: '',
    episode_no: '',
    location: '',
    customer_id: null,
    episode_id: null,
  }

  feedbackTypeFormData.value = {
    customerType: null,
    sourceType: null,
    formType: null,
  }

  feedbackFormData.value = {}
    
  useFeedbackEntry().updateCurrentFeedback({
    customer: {
      customer_id: null,
      name: '',
      uhid: '',
      episode_no: '',
      email: '',
      phone: '',
      feedback_datetime: null,
      location: null,
    },
    unit_id: null,
    location_name: null,
    feedback_type: '',
    source_type: '',
    form_type: '',
    customer_type: '',
    feedback: [],
    attachment: null,
    is_otp_verification: false,
    send_google_review_invitation: false,
  })

  // Reset OTP state
  otpVerified.value = false
  isOtpVerificationSelected.value = hasOtpVerificationConfig.value
  isSendGoogleReviewInvitationSelected.value = hasGoogleReviewInvitationConfig.value

  submitLocation.value = false
  feedbackId.value++
  currentStep.value = 0
}

const onSubmit = async data => {
  submitLocation.value = true

  // Update feedback with OTP and Google review selections
  useFeedbackEntry().updateCurrentFeedback({
    is_otp_verification: isOtpVerificationSelected.value,
    send_google_review_invitation: isSendGoogleReviewInvitationSelected.value?1:0,
  })

  // If OTP verification is selected, send OTP first
  if (isOtpVerificationSelected.value && !otpVerified.value) {
    await sendOtp()

    return
  }

  // If OTP is not required or already verified, submit directly
  await useFeedbackEntry().submitCurrentFeedback(false, onSuccess)
  submitLocation.value = false
}


const isCustomerApiConfigured = ref(false)

// Config flags from unit config_heads (determines if checkboxes should be shown)
const hasOtpVerificationConfig = ref(false)
const hasGoogleReviewInvitationConfig = ref(false)

// User selection checkboxes (default to true when config is enabled)
const isOtpVerificationSelected = ref(false)
const isSendGoogleReviewInvitationSelected = ref(false)

// OTP Modal state
const showOtpModal = ref(false)
const otpValue = ref('')
const otpLoading = ref(false)
const otpError = ref('')
const otpVerified = ref(false)

const auth = userAuthState()

// check customer selection api available
await useApi(createUrl('/configurations/customer-api-status', {
  query: {
    unit_id: cookieRef('selectedUnit'),
  },
}), {
  afterFetch: response => {
    isCustomerApiConfigured.value = response?.data?.status
  },
})

// Get unit config for OTP and Google review settings
const selectedUnitId = computed(() => cookieRef('selectedUnit').value)

const checkUnitConfig = () => {
  const unit = auth.user?.units?.find(u => u.id == selectedUnitId.value)

  hasOtpVerificationConfig.value = !!unit?.config_heads?.some(ch => ch?.type === 'feedback_collection' && ch?.key === 'is_otp_verification')
  hasGoogleReviewInvitationConfig.value = !!unit?.config_heads?.some(ch => ch?.type === 'feedback_collection' && ch?.key === 'send_google_review_invitation')

  // Default selections to true when config is enabled
  isOtpVerificationSelected.value = hasOtpVerificationConfig.value
  isSendGoogleReviewInvitationSelected.value = hasGoogleReviewInvitationConfig.value
}

// Check config on mount and when unit changes
watch(selectedUnitId, () => {
  checkUnitConfig()
}, { immediate: true })

onBeforeMount(() => {
  useFeedbackEntry().resetCurrentFeedback()
})

watch(feedbackTypeFormData, () => {
  if(feedbackTypeFormData.value?.customerType === 'PATIENT'){
    if (isCustomerApiConfigured.value &&(!isCustomerDialogOpen.value && customerInfoFormData.value?.customer_id === null)) {
      isCustomerDialogOpen.value = true
    }
  }else{
    customerInfoFormData.value = {
      name: '',
      phone: '',
      email: '',
      uhid: '',
      episode_no: '',
      location: '',
      customer_id: null,
      episode_id: null,
      feedback_datetime: customerInfoFormData.value?.feedback_datetime ?? null,
    }
  }
}, {
  deep: true,
  immediate: true,
})

// watch(customerInfoFormData, () => {
//   refCustomerInfoForm.value?.resetValidation()
 
// })


const getResponseValue = response => {
  if (Array.isArray(response)) {
    return response.map(item => item?.label ?? item?.value ?? item).join(', ')
  }

  return response?.label ?? response?.value ?? response
}

// Transform feedback data for AppQAList
const feedbackQAItems = computed(() => {
  const feedback = useFeedbackEntry().getFilledFeedback?.feedback || []

  return feedback.map(item => {
    // Get answer value based on question type
    let answer = ''
    if (item.question_type === 'attachments' || item.question_type === 'ai_voice') {
      // No text answer for file-based question types
    } else if (item.question_type === 'smile') {
      answer = item.response?.label ?? ''
    } else {
      answer = getResponseValue(item.response)
    }

    // Handle ai_voice attachment (singular)
    let attachment = null
    if (item.question_type === 'ai_voice' && item.response) {
      attachment = item.response instanceof File ? URL.createObjectURL(item.response) : item.response
    }

    return {
      question: item.question_label,
      answer,
      question_type: item.question_type,
      answer_reason: item.reason_response,

      // For attachment type - attachment objects
      attachment,

      // For attachments type - array of attachment objects
      attachments: item.question_type === 'attachments' && Array.isArray(item.response)
        ? item.response.map((file, index) => ({
          id: index,
          name: file?.name || `File ${index + 1}`,
          url: file instanceof File ? URL.createObjectURL(file) : file,
          mime_type: file?.type || 'application/octet-stream',
          size: file?.size || 0,
        }))
        : [],
    }
  })
})

const updateCustomerData = data => {
  customerInfoFormData.value = {
    ...customerInfoFormData.value,
    ...data,
  }
}

// * This FN validate & load data from url query
const loadPageQuery = async () => {
  if (
    route.query?.episode &&
    route.query?.source_type &&
    route.query?.form_type &&
    route.query?.location
  ) {
    // Customer
    const {
      data: episode,
    } = await useApi(createUrl(`/masters/episodes/${route.query?.episode}`))
    
    // Location
    let location
    if (episode.location) {
      location = episode.value.location
    } else {
      location = await useApi(createUrl(`/masters/locations/${route.query?.location}`))
      location = location.data
    }

    // Load data into forms
    customerInfoFormData.value = {
      ...episode.value.customer,
      customer_id: episode.value.customer.id,
      episode_id: episode.value.id,
      episode_no: episode.value.code,
      location: location.value,
    }

    feedbackTypeFormData.value = {
      customerType: 'PATIENT',
      sourceType: Number(route.query?.source_type),
      formType: Number(route.query?.form_type),
    }

    // Update state
    useFeedbackEntry().updateCurrentFeedback({
      customer_type: feedbackTypeFormData.value?.customerType,
      source_type: feedbackTypeFormData.value?.sourceType,
      form_type: feedbackTypeFormData.value?.formType,
      feedback_type: type.value,
      feedback: [],
    })
    useFeedbackEntry().updateCurrentFeedback({
      customer: customerInfoFormData.value,
      unit_id: cookieRef('selectedUnit'),
      feedback: [],
    })

    currentStep.value = 2
  }
}

onMounted(() => {
  loadPageQuery()
})

// OTP Verification Functions
const sendOtp = async () => {
  otpLoading.value = true
  otpError.value = ''

  try {
    const response = await $api('feedbacks/send-otp', {
      method: 'POST',
      body: {
        phone: customerInfoFormData.value.phone,
        unit_id: cookieRef('selectedUnit').value,
        customer: {
          name: customerInfoFormData.value.name,
          phone: customerInfoFormData.value.phone,
          email: customerInfoFormData.value.email,
          uhid: customerInfoFormData.value.uhid,
          episode_no: customerInfoFormData.value.episode_no,
          customer_id: customerInfoFormData.value.customer_id,
          episode_id: customerInfoFormData.value.episode_id,
        },
      },
    })

    console.log('OTP Send Response:', response)

    if (response?.status) {
      showOtpModal.value = true
    } else {
      otpError.value = response?.message || 'Failed to send OTP'
      submitLocation.value = false
    }
  } catch (error) {
    otpError.value = error?.message || 'Failed to send OTP'
    submitLocation.value = false
  } finally {
    otpLoading.value = false
  }
}

const verifyOtp = async () => {
  if (otpValue.value.length !== 6) {
    otpError.value = 'Please enter a valid 6-digit OTP'

    return
  }

  otpLoading.value = true
  otpError.value = ''

  try {
    const response = await $api('feedbacks/verify-otp', {
      method: 'POST',
      body: {
        phone: customerInfoFormData.value.phone,
        otp: otpValue.value,
        unit_id: cookieRef('selectedUnit').value,
      },
    })

    if (response) {
      otpVerified.value = true
      showOtpModal.value = false
      otpValue.value = ''

      // Proceed with feedback submission after OTP verification
      submitFeedbackAfterOtp()
    } else {
      otpError.value = response?.data?.message || 'Invalid OTP'
    }
  } catch (error) {
    otpError.value = error?.message || 'OTP verification failed'
  } finally {
    otpLoading.value = false
  }
}

const closeOtpModal = () => {
  showOtpModal.value = false
  otpValue.value = ''
  otpError.value = ''
  submitLocation.value = false
}

const resendOtp = async () => {
  otpValue.value = ''
  otpError.value = ''
  await sendOtp()
}

const submitFeedbackAfterOtp = async () => {
  // Update feedback with OTP and Google review selections
  useFeedbackEntry().updateCurrentFeedback({
    is_otp_verification: isOtpVerificationSelected.value,
    send_google_review_invitation: isSendGoogleReviewInvitationSelected.value?1:0,
  })

  await useFeedbackEntry().submitCurrentFeedback(false, onSuccess)
  submitLocation.value = false
}
</script>

<template>
  <!-- 👉 Stepper -->
  <!-- <VBreadcrumbs :items="breadcrumbs" /> -->

  <div class="mb-6">
    <AppStepper
      v-model:current-step="currentStep"
      :items="iconsSteps"
      :is-active-step-valid="isCurrentStepValid"
    />
  </div>

  <div>
    <!-- 👉 stepper content -->
    <VForm>
      <VWindow
        v-model="currentStep"
        :touch="false"
        class="disable-tab-transition"
      >
        <VWindowItem class="bg-var-theme-white">
          <VForm
            ref="refFeedbackTypeForm"
            @submit.prevent="validateFeedbackTypeForm"
          >
            <FeedbackType
              :data="feedbackTypeFormData"
              :current-step="currentStep"
              @update:current-step="updateCurrentStep"
              @update:feedback-type-form-data="feedbackTypeFormData = $event"
            />  
          </VForm>
        </VWindowItem>
        <VWindowItem>
          <VForm
            ref="refCustomerInfoForm"
            @submit.prevent="validateCustomerInfoForm"
          >
            <CustomerInfo
              :data="customerInfoFormData"
              :current-step="currentStep"
              @update:customer-info-form-data="customerInfoFormData = $event"
              @update:current-step="updateCurrentStep"
            />
          </VForm>
        </VWindowItem>
        <VWindowItem>
          <VForm
            ref="refFeedbackForm"
            @submit.prevent="validateFeedbackForm"
          >
            <Component
              :is="questionFeedbackComponent"
              :key="feedbackId"
              :current-step="currentStep"
              @update:current-step="updateCurrentStep"
              @update:feedback-type-form-data="feedbackFormData = $event"
              @update:reset-feedback-form="resetFeedbackForm"
            />
          </VForm>
        </VWindowItem>

        <VWindowItem>
          <div>
            <VForm
              ref="refReviewAndSubmitForm"
              @submit.prevent="onSubmit"
            >
              <VCard
                variant="flat"
                class="border"
              >
                <VCardText>
                  <div class="text-h5">
                    Review & Submit
                  </div>
                  <span class="text-body-2">Check details and responses before final submission</span>
                </VCardText>
                
                <VCardText>
                  <div class="text-base">
                    <div class="custom-background px-3 py-3 border-sm rounded-lg">
                      <h6 class="text-base font-weight-medium mb-2 text-primary">
                        Form Type
                      </h6>

                      <p class="d-flex align-center text-body-2 mb-1">
                        <span class="label">Form Type:</span>
                        <span class="font-weight-bold">{{ useFeedbackEntry().getFilledFeedback?.form_type?.title }}</span>
                      </p>
                         
                      <p class="d-flex text-body-2 align-center">
                        <span class="label">{{ $t('Customer') +' Type: ' }}</span>
                        <span class="font-weight-bold">{{ useFeedbackEntry().getFilledFeedback?.source_type?.title }}</span>
                      </p>
                    </div>

                    <div class="custom-background px-3 py-3 border-sm mt-4 rounded-lg">
                      <h6 class="text-base font-weight-medium mb-2 text-primary">
                        {{ $t('Customer') }} Info
                      </h6>
                      <p class="mb-1 text-body-2 d-flex align-center">
                        <span class="label">
                          Name :  
                        </span>
                        <span class="font-weight-bold">
                          {{ useFeedbackEntry().getFilledFeedback?.customer?.name }}
                        </span>
                      </p>
                      <p
                        v-if="useFeedbackEntry().getFilledFeedback?.customer?.uhid"
                        class="mb-1 text-body-2 d-flex align-center"
                      >
                        <span class="label">
                          UHID :  
                        </span>
                        <span class="font-weight-bold">
                          {{ useFeedbackEntry().getFilledFeedback?.customer?.uhid }}
                        </span>
                      </p>
                      <p
                        v-if="useFeedbackEntry().getFilledFeedback?.customer?.episode_no"
                        class="mb-1 text-body-2 d-flex align-center"
                      >
                        <span class="label">
                          Episode No :  
                        </span>
                        <span class="font-weight-bold">
                          {{ useFeedbackEntry().getFilledFeedback?.customer?.episode_no }}
                        </span>
                      </p>
                      <p class="mb-1 text-body-2 d-flex align-center">
                        <span class="label">
                          Mobile No :
                        </span>
                        <span class="font-weight-bold">
                          {{ useFeedbackEntry().getFilledFeedback?.customer?.phone }}
                        </span>
                      </p>
                      <p class="mb-1 text-body-2 d-flex align-center">
                        <span class="label">
                          Feedback Date :
                        </span>
                        <span class="font-weight-bold">
                          {{ useFeedbackEntry().getFilledFeedback?.customer?.feedback_datetime }}
                        </span>
                      </p>
                      <p class="mb-1 text-body-2 d-flex align-center">
                        <span class="label">
                          Location :
                        </span>
                        <span class="font-weight-bold">

                          {{ useFeedbackEntry().getFilledFeedback?.customer?.location?.name }}
                        </span>
                      </p>
                    </div>

                    <!-- QUESTION & RESPONSE -->
                    <div class="mt-4">
                      <AppQAList
                        :items="feedbackQAItems"
                        title="Feedback Response"
                        header-icon="tabler-message-check"
                        header-color="primary"
                      />
                    </div>

                    <!-- OTP Verification and Google Review Invitation Checkboxes -->
                    <div
                      v-if="customerInfoFormData.phone && (hasOtpVerificationConfig || hasGoogleReviewInvitationConfig)"
                      class="px-3 py-3 border-sm mt-4 rounded-lg"
                    >
                      <h6 class="text-base font-weight-medium mb-2 text-primary">
                        Additional Options
                      </h6>
                      <VRow>
                        <VCol
                          v-if="hasOtpVerificationConfig"
                          cols="12"
                          md="6"
                        >
                          <VCheckbox
                            v-model="isOtpVerificationSelected"
                            color="primary"
                            label="Verify phone number with OTP"
                            hide-details
                          />
                        </VCol>
                        <VCol
                          v-if="hasGoogleReviewInvitationConfig"
                          cols="12"
                          md="6"
                        >
                          <VCheckbox
                            v-model="isSendGoogleReviewInvitationSelected"
                            color="primary"
                            label="Send Google review invitation"
                            hide-details
                          />
                        </VCol>
                      </VRow>
                    </div>
                  </div>
                </VCardText>
              </VCard>
              
              <VCard
                class="mt-6 border"
                variant="flat"
              >
                <VCardText>
                  <div class="d-flex flex-wrap gap-4 justify-space-between">
                    <VBtn
                      color="secondary"
                      variant="tonal"
                      :disabled="currentStep === 0"
                      @click="currentStep--"
                    >
                      <VIcon
                        icon="tabler-arrow-left"
                        start
                        class="flip-in-rtl"
                      />
                      Previous
                    </VBtn>

                    <VBtn
                      color="success"
                      type="submit"
                      variant="flat"
                      :loading="submitLocation"
                    >
                      submit
                    </VBtn>
                  </div>
                </VCardText>
              </VCard>

              <!--
                <VRow>
                <VCol cols="12 px-0">
                <VCardTitle level="4">
                <div class="text-h5">
                Review & Submit
                </div>
                <span class="text-body-2">Check details and responses before final submission</span>
                </VCardTitle>
                </VCol>
                <VCol
                cols="12"
                class="px-0"
                >
                <VCardItem class="px-0" />
                </VCol>
                <VCol cols="12">
                  
                </VCol>
                </VRow> 
              -->
            </VForm>
          </div>
        </VWindowItem>
      </VWindow>
    </VForm>
  </div>

  <CustomerFetchDialog
    v-model:isDialogOpen="isCustomerDialogOpen"
    @update:customer-dialog-data="updateCustomerData"
    @update:clear-customer-selection="feedbackTypeFormData.customerType = ''"
  />

  <!-- OTP Verification Modal -->
  <VDialog
    v-model="showOtpModal"
    max-width="400"
    persistent
  >
    <VCard>
      <VCardTitle class="text-center pt-6">
        <VIcon
          icon="tabler-shield-lock"
          size="48"
          color="primary"
          class="mb-2"
        />
        <div class="text-h5">
          Verify Phone Number
        </div>
        <p class="text-body-2 text-medium-emphasis mt-2 mb-0">
          Enter the 6-digit OTP sent to {{ customerInfoFormData.phone }}
        </p>
      </VCardTitle>

      <VCardText class="pt-4">
        <VOtpInput
          v-model="otpValue"
          :disabled="otpLoading"
          type="number"
          length="6"
          class="pa-0 justify-center"
          @finish="verifyOtp"
        />

        <VAlert
          v-if="otpError"
          type="error"
          variant="tonal"
          class="mt-4"
        >
          {{ otpError }}
        </VAlert>

        <div class="text-center mt-4">
          <span class="text-body-2 text-medium-emphasis">Didn't receive the code?</span>
          <VBtn
            variant="text"
            size="small"
            color="primary"
            :loading="otpLoading"
            @click="resendOtp"
          >
            Resend OTP
          </VBtn>
        </div>
      </VCardText>

      <VCardActions class="justify-center pb-6">
        <VBtn
          variant="outlined"
          color="secondary"
          :disabled="otpLoading"
          @click="closeOtpModal"
        >
          Cancel
        </VBtn>
        <VBtn
          color="primary"
          :loading="otpLoading"
          :disabled="otpValue.length !== 6"
          @click="verifyOtp"
        >
          Verify OTP
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<style scoped>
.label {
  inline-size: 150px;
}
</style>

<style lang="scss">
.custom-background{
  background-color: rgba(0, 102, 255, 5%);
}
</style>
